
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'orderBy', pure: false })
export class OrderBy implements PipeTransform {
  value: string[] = [];
  static _orderByComparator(a: any, b: any): number {

    if (a === null || a === undefined) { a = 0; }
    if (b === null || b === undefined) { b = 0; }

    if ((isNaN(parseFloat(a)) || !isFinite(a)) || (isNaN(parseFloat(b)) || !isFinite(b))) {
      if (!isNaN(Date.parse(a)) || !isNaN(Date.parse(b))) {
        if (a < b) { return -1; }
        if (a > b) { return 1; }
      } else {// true
        a = a.toString();
        b = b.toString();
        if (a.toLowerCase() < b.toLowerCase()) { return -1; }
        if (a.toLowerCase() > b.toLowerCase()) { return 1; }
      }
    } else {
      if (parseFloat(a) < parseFloat(b)) { return -1; }
      if (parseFloat(a) > parseFloat(b)) { return 1; }
    }
    return 0; // equal each other
  }
  public transform(input: any, config = '+'): any {
    config = JSON.parse(localStorage.getItem('sortOrder'));
    if (!input) {
      return input;
    }
    const value = [...input];
    if (!Array.isArray(value)) {
      return value;
    }
    return value.sort(function (a: any, b: any) {
      for (let i = 0; i < config.length; i++) {
        const desc = config[i].substr(0, 1) === '-';
        const property = config[i].substr(0, 1) === '+' || config[i].substr(0, 1) === '-'
          ? config[i].substr(1) : config[i];

        let aValue = a[property];
        let bValue = b[property];

        const propertySplit = property.split('.');

        if (aValue === undefined && bValue === undefined && propertySplit.length > 1) {
          aValue = a;
          bValue = b;
          for (let j = 0; j < propertySplit.length; j++) {
            aValue = aValue[propertySplit[j]];
            bValue = bValue[propertySplit[j]];
          }
        }

        const comparison = !desc ? OrderBy._orderByComparator(aValue, bValue)
          : -OrderBy._orderByComparator(aValue, bValue);

        if (comparison !== 0) { return comparison; }
      }
      return 0; // equal each other
    });
  }
}



// WEBPACK FOOTER //
// ./src/models/orderBy.ts